import { IconButton } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";

type Props = {
	variant: "filled" | "outlined";
	icon: string;
	onPress: () => void;
	loading?: boolean;
	disabled?: boolean;
	a11yLabel?: string;
};

const RecorderIconButton = ({
	variant,
	icon,
	onPress,
	loading,
	disabled,
	a11yLabel,
}: Props) => {
	const theme = useAppTheme();

	if (variant === "filled") {
		return (
			<IconButton
				icon={icon}
				mode="contained"
				size={24}
				containerColor={theme.colors.primary}
				iconColor={theme.colors.onPrimary}
				loading={loading}
				disabled={disabled}
				onPress={onPress}
				accessibilityLabel={a11yLabel}
				style={{ margin: 0, width: 40 }}
			/>
		);
	}

	return (
		<IconButton
			icon={icon}
			mode="outlined"
			size={24}
			iconColor={theme.colors.onSurfaceVariant}
			disabled={disabled}
			onPress={onPress}
			accessibilityLabel={a11yLabel}
			style={{
				margin: 0,
				width: 40,
				borderColor: theme.colors.outline,
			}}
		/>
	);
};

export default RecorderIconButton;
